import { Injectable } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { AppFacade } from '@rci/self-serve-fido/state/app.facade';
import { PageContent, PageContentEntity, PageContentFacadeService } from '@rogers/self-serve-common/page-content';

@Injectable({
  providedIn: 'root',
})
export class PageContentService {
  constructor(
    private readonly appFacade: AppFacade,
    private readonly pageContentFacadeService: PageContentFacadeService,
    private readonly translate: TranslateService,
  ) {}

  getPageContent$(pageName: string, province?: string): Observable<PageContent> {
    return this.fetchPageContent$(pageName, province).pipe(
      map(pageContentEntity => {
        if (!pageContentEntity) {
          return { alerts: [], banners: [], supportContents: [] };
        }

        return {
          alerts: pageContentEntity.alerts,
          banners: pageContentEntity.banners,
          supportContents: pageContentEntity.supportContents,
        };
      }),
    );
  }

  private fetchPageContent$(pageName: string, province?: string): Observable<PageContentEntity> {
    // Fallback in cases when province is not defined or empty, use province set in the header of the page
    const region: string = province ? province : this.appFacade.province;

    return this.translate.stream('lang').pipe(
      switchMap(lang => {
        return this.pageContentFacadeService.getPageContents$(pageName, lang, region);
      }),
    );
  }
}
